import React, { Children, isValidElement, useEffect, useRef } from "react";
import { AccordionItemProvider, useAccordionItem, useAccordionItemState } from "../../context/ComponentesSlots";
import Slot, { DURACAO_ABERTURA } from "./Slot";
import { Trigger } from "./Trigger";
import { rolarAteAVista } from "./rolagem";

const ContainerChild = ({ trigger, slot }: { trigger: React.ReactNode, slot: React.ReactNode }) => {
    const { isOpen, toggle } = useAccordionItemState();

    const caixa = useRef<HTMLDivElement>(null);
    const anterior = useRef(false);

    useEffect(() => {
        const abriu = isOpen && !anterior.current;

        anterior.current = isOpen;

        if (!abriu) return;

        const timer = setTimeout(() => {
            if (caixa.current) rolarAteAVista(caixa.current);
        }, DURACAO_ABERTURA * 1000 + 20);

        return () => clearTimeout(timer);
    }, [isOpen]);

    const preventClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return <div ref={caixa} onClick={toggle}
        className="group/trigger !py-4 !px-[6px] w-full border-b cursor-pointer border-gray-200" data-open={isOpen ? "true" : "false"}>
        {trigger}

        <div onClick={preventClick}>
            {slot}
        </div>
    </div>
};

export const Container = ({
    children,
    id,
    opened = false,
}: {
    children: React.ReactNode;
    id?: string;
    opened?: boolean;
}) => {
    const item = useAccordionItem(id, opened);

    const trigger = Children.map(children, (child) =>
        isValidElement(child) && child.type === Trigger ? child : null
    );

    const slot = Children.map(children, (child) => isValidElement(child) && child.type === Slot ? child : null);

    return (
        <AccordionItemProvider value={item}>
            <ContainerChild trigger={trigger} slot={slot} />
        </AccordionItemProvider>
    );
};
